module.exports = "<div class=\"row bgHeading\"><h2>Essential downloads</h2></div>\n<div class=\"col-12\" style=\"min-height: 600px;\">\n  <div class=\"col-12\" [innerHtml]=\"intro\"></div>\n  <a *ngFor=\"let f of files\" [href]=\"'http://api.sciencefairfarnorth.ac.nz/downloads/' + f.FileName\" target=\"_blank\" class=\"fileRow\">\n    <div class=\"flex-row\">\n\n      <div style=\"font-size:14px;margin:15px 5px 0 0\"><i class=\"fa fa-file fa-lg\"></i> {{f.Display}}</div>\n    </div>\n\n  </a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/downloads/downloads.component.html
// module id = 322
// module chunks = 1